import axios from "axios";
import { utmBaseUrl } from "../helpers/constants";

export const getAllFlights = ({ queryKey }) => {
  const flightType = queryKey[2];
  // console.log(flightType, "token");
  return axios.get(`${utmBaseUrl}/v1/api/utm/flight/flight-details/${flightType}/1`, {
    headers: { "x-access-token": queryKey[1] },
  });
};

export const addFlight = ({ token, payload }) => {
  // console.log("adding drone", payload);
  const droneId = payload.droneId;
  // remove droneId from payload
  delete payload.droneId;
  return axios.post(`${utmBaseUrl}/v1/api/utm/flight/${droneId}/flight-registration`, payload, {
    headers: { "x-access-token": token },
  });
};


export const getFlightDetails = (flightId, token) => {
  return axios.get(`${utmBaseUrl}/v1/api/utm/flight/flight-detail/${flightId}`, {
    headers: { "x-access-token": token },
  })
}
// TODO add token
// export const getZones = () => {
//   return axios.get(`${base_url}/v1/api/zones/`);
// };


export const getAllBlockFlightTime = (token) => {
  return axios.get(`${utmBaseUrl}/v1/api/utm/block-flights-time`, {
    headers: { "x-access-token": token },
  });
}

export const getBlockFlightDetails = (token, blockFlightId) => {
  return axios.get(`${utmBaseUrl}/v1/api/utm/block-flights-time/${blockFlightId}`, {
    headers: { "x-access-token": token },
  })
}
